import './map-pop-up.css';
import Map from '../MapClasses/Map';
import MapFilter from '../MapClasses/MapFilters';
import mainConfig from '../../../mainConfig';

export default new class MapPopUp {
    constructor() {
        this.yandexScriptSrc = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&mode=debug';

        this.clickInitPopUp = '.btn-map';
        this.clickInitProductPopUp = '.btn-map-product';
        this.MapPopUpWrapper = '.map-pop-up-wrapper';
        this.closeMapBtn = '.map-pop-up__close';
        this.mapPopUp = '.map-pop-up';
        this.mapPopUpInner = '.map-pop-up-inner';
        this.productOffersAddress = '.product-offers__address';
        this.cartOffersAddress = '.cart-item__address';
    }

    popUpTemplate() {
        return require('./map-pop-up.pug')();
    }

    popUpHandler() {
        $(document).on('click', `${this.clickInitPopUp}, ${this.cartOffersAddress}, ${this.productOffersAddress}, ${this.clickInitProductPopUp}`, (e) => {
            e.stopPropagation();
            e.preventDefault();

            //upload yandex map script
            $.getScript(mainConfig.yandexScriptSrc, () => {

                //run yandex map create after script fully loaded
                let mapPupUpWrapper = $(this.MapPopUpWrapper),
                    mapInitOptions = {},
                    _clickTarget = $(e.target);

                mapPupUpWrapper.html(this.popUpTemplate());

                if(_clickTarget.hasClass(this.clickInitPopUp.slice(1))) {

                    MapFilter.iProductID = $(_clickTarget).attr('data-product-id');

                    mapInitOptions = {
                        noScroll: false,
                        balloonOpenResolutionFlag: true,
                        ajaxData: false
                    };
                } else if(_clickTarget.hasClass(this.clickInitProductPopUp.slice(1))) {
                    mapInitOptions = {
                        noScroll: false,
                        balloonOpenResolutionFlag: true,
                        ajaxData: {
                            data: {
                                product_id: $(_clickTarget).attr('data-product-id'),
                                date: $('.oc-filter-shopaholic._calendar-data ._start-date input').val(),
                                period: $('.oc-filter-shopaholic._calendar-data ._period input').val()
                            },
                            mapApiName: 'getProductPopUpItems'
                        }
                    };
                } else if(_clickTarget.hasClass(this.productOffersAddress.slice(1))) {

                    let data = {
                        'product_id': _clickTarget.parents('.product-offers__owner').attr('data-product-id'),
                        'offer_id': _clickTarget.parents('.product-offers__owner').attr('data-offer-id')
                    };

                    mapInitOptions = {
                        noScroll: false,
                        balloonOpenResolutionFlag: false,
                        ajaxData: {
                            data: data,
                            mapApiName: 'getAddressPopUpItems'
                        }
                    };

                    mapPupUpWrapper.find('.map-for-catalog-filters').hide();
                } else if(_clickTarget.hasClass(this.cartOffersAddress.slice(1))) {

                    let data = {
                        'product_id': _clickTarget.parents('.cart-item').attr('data-product-id'),
                        'offer_id': _clickTarget.parents('.cart-item').attr('data-offer-id')
                    };

                    mapInitOptions = {
                        noScroll: false,
                        balloonOpenResolutionFlag: false,
                        ajaxData: {
                            data: data,
                            mapApiName: 'getAddressPopUpItems'
                        }
                    };

                    mapPupUpWrapper.find('.map-for-catalog-filters').hide();
                }

                Map.mapInit(mapInitOptions);
            });
        });

        $(document).on('mousedown', `${this.closeMapBtn}, ${this.mapPopUp}`, (e) => {
            e.stopPropagation();
            e.preventDefault();
            Map.deleteMap();

            MapFilter.iProductID = false;

            let mapPupUpWrapper = $(this.MapPopUpWrapper);
            mapPupUpWrapper.html('');

            $('html,body').off('mousewheel.mapPopup');
        });

        $(document).on('mousedown', this.mapPopUpInner, (e) => {
            e.stopPropagation();
        });

        $(document).on('mouseenter', this.mapPopUp, function () {
            $('html,body').on('mousewheel.mapPopup', function (e) {
                e.preventDefault();
            });
            $(this.mapPopUp).on('mousewheel', function (e) {
                var step = 15;
                var direction = e.originalEvent.deltaY > 0 ? 1 : -1;
                $(this).scrollTop($(this).scrollTop() + step * direction);
            });

        });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/map-pop-up/MapPopUp.js